import React from 'react';

import { useMatchMedia } from '@betterment/js-runtime';
import { Link } from '@betterment/samba-react';
import { Box, Flex, get as themeGet } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

import { urlBuilder } from '../../Shared/urlBuilder';

const LinkTab = styled(Link)`
  && {
    text-decoration: none;
    font-size: 16px;
    font-weight: normal;
    color: ${themeGet('colors.bmtGrey50')} !important;
    background-color: ${themeGet('colors.bmtWhite')};
    padding: 0;
    margin: 0;
    border-radius: 0;
    outline: none;
    margin-right: 3.2rem;
  }
  &&.activeTab {
    border-bottom: 2px solid ${themeGet('colors.bmtGrey90')};
    color: ${themeGet('colors.bmtGrey90')}} !important;
  }
  :hover {
    color: ${themeGet('colors.bmtGrey90')}} !important;
  }
`;

const TabNavigation: React.FC = () => {
  const isAtLeastMedium = useMatchMedia('atLeastMedium');

  return (
    <Box paddingX={isAtLeastMedium ? '0' : '8'}>
      <Flex alignItems="baseline" justifyContent="flex-start" pt="8">
        <LinkTab href="#" className="activeTab">
          <Box pb="4">Available Rewards</Box>
        </LinkTab>
        <LinkTab href={urlBuilder.appEarnedRewards.absolute()}>
          <Box pb="4">Earned Rewards</Box>
        </LinkTab>
      </Flex>
    </Box>
  );
};

export default TabNavigation;
